module.exports = __webpack_public_path__ + "static/img/son14_active.04877f2c.png";